import React, { useState } from 'react'
import { Drawer } from 'antd'
import Select from 'react-select'
import Creatable from 'react-select/creatable'

import { usePet, useToggle } from '../../modules'
import { useHistory } from 'react-router-dom'

const NewSupplier = ({ string = '', onPerform = () => null }) => {
    const [name, setName] = useState(string)
    const [displayName, setDisplayName] = useState(string)
    const [phones, setPhones] = useState([])
    const [emails, setEmails] = useState([])
    const [contactName, setContactName] = useState()
    const [contactPhone, setContactPhone] = useState()
    const [contactEmail, setContactEmail] = useState()
    const [address, setAddress] = useState()
    const [type, setType] = useState({ label: 'Regular', value: 'Regular' })

    const [visible, toggleVisible] = useToggle(true)

    const history = useHistory()

    const close = () => {
        toggleVisible()
        setName()
        setDisplayName()
        setPhones([])
        setEmails([])
        setContactName()
        setContactPhone()
        setContactEmail()
        setAddress()
        setTimeout(() => history.goBack(), 100)
    }

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'displayName':
                setDisplayName(e.target.value)
                break

            case 'contactName':
                setContactName(e.target.value)
                break

            case 'contactPhone':
                setContactPhone(e.target.value)
                break

            case 'contactEmail':
                setContactEmail(e.target.value)
                break

            case 'address':
                setAddress(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        notif('Supplier has been added', ops('success'))
        onPerform(data)
        close()
    }

    const [{ loading: newLoading }, newSupplier] = usePet('newSupplier', {
        name, 
        displayName, 
        phones: phones.map(phone => phone.label), 
        emails: emails.map(email => email.label), 
        contactName, 
        contactPhone, 
        contactEmail, 
        address,
        type: type?.value
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Adding new supplier...' } })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ newSupplier } className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
                </div>
            }
            width="35%">
            <p className="font-extrabold text-3xl mb-0">New Supplier</p>
            <div className="flex flex-wrap mt-3">
                <h4>General Information</h4>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Supplier Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-contains"
                        type="text"
                        name="name"
                        value={name}
                        onChange={modify}
                        placeholder="Supplier Name" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Display Name (Optional)
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-d-name"
                        type="text"
                        name="displayName"
                        value={displayName}
                        onChange={modify}
                        placeholder="Display Name" />
                    <p className="text-gray-500 text-xs italic">This name will appear in purchase orders. The supplier's name will be used if not set.</p>
                </div>
                <h4>Contact Information</h4>
                <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Email
                    </label>
                    <Creatable
                        isMulti
                        onCreateOption={x => setEmails([...emails, { label: x, value: x }])}
                        className="min-w-56 mr-4"
                        value={emails}
                        onChange={setEmails}
                        options={emails.map(email => ({ label: email.label, value: email.value }))}
                        placeholder="Add Email Addresses" />
                </div>
                <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Phone Number
                    </label>
                    <Creatable
                        isMulti
                        onCreateOption={x => setPhones([...phones, { label: x, value: x }])}
                        className="min-w-56 mr-4"
                        value={phones}
                        onChange={setPhones}
                        options={phones.map(phone => ({ label: phone.label, value: phone.value }))}
                        placeholder="Add Phone Numbers" />
                </div>
                <div className="w-full px-3 mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Type
                    </label>
                    <Select
                        className="min-w-56 mr-4"
                        value={type}
                        onChange={setType}
                        options={['Regular', 'Marketer'].map(str => ({ label: str, value: str }))}
                        placeholder="Select Type" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Address
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-c-address"
                        rows="5"
                        name="address"
                        value={address}
                        onChange={modify}
                        placeholder="P. O. Box XYZ" />
                </div>
                <h4>Contact Person</h4>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-c-name"
                        type="text"
                        name="contactName"
                        value={contactName}
                        onChange={modify}
                        placeholder="Kimani George" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Phone Number
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-c-phone"
                        type="text"
                        name="contactPhone"
                        value={contactPhone}
                        onChange={modify}
                        placeholder="07XXXXXXXX" />
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Email Address (Optional)
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-c-email"
                        type="email"
                        name="contactEmail"
                        value={contactEmail}
                        onChange={modify}
                        placeholder="person@email.com" />
                </div>
            </div>
        </Drawer>
    )
}

export default NewSupplier